<template>
  <div>
    <div
      class="text-item"
      v-if="!!yearValue"
    >
      <div
        class="text-label"
        v-t="'product.year'"
      />
      <div class="text-value">
        {{ yearValue }}
      </div>
    </div>
    <div
      class="text-item"
      v-for="service in data.service_list"
      :key="service.service_name"
    >
      <div class="text-label">
        {{ service.service_name }}
      </div>
      <div class="text-value">
        <span v-text="textValue(service)" />
        <span
          v-text="renderExtra(service)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {
    SERVICE_ID_DISCOVERY,
    SERVICE_ID_ERPAPI,
    SERVICE_ID_ERPHELP,
    SERVICE_ID_BILLS,
    SERVICE_ID_PROCESS,
    SERVICE_ID_STAT,
    SERVICE_ID_GOOGLE_CID,
    SERVICE_ID_ADS_ADVANCE,
    SERVICE_ID_ADS_SERVICE,
    SERVICE_ID_STATION,

    ORDER_TYPE_NEW,
    ORDER_TYPE_APPEND,
    ORDER_TYPE_RENEW,
    // ORDER_TYPE_UPGRADE,
    ORDER_TYPE_CHANGE_RENEW,
    ORDER_TYPE_PROMOTION_RENEW,
    ORDER_TYPE_TRANSFER
  } from '@utils/constants'

  export default {
    name: 'RenderService',
    props: {
      data: {
        required: true,
        type: Object,
      }
    },
    computed: {
      yearValue() {
        const {
          type,
          year,
          service_list,
          valid_from = "",
          valid_to = ""
        } = this.data;
        const serviceId = service_list.map(s => ~~s.service_id);
        if (type == ORDER_TYPE_NEW || type == ORDER_TYPE_APPEND || type == ORDER_TYPE_RENEW || type == ORDER_TYPE_CHANGE_RENEW || type == ORDER_TYPE_PROMOTION_RENEW || type == ORDER_TYPE_TRANSFER) {
          if (serviceId.includes(SERVICE_ID_ERPHELP)) {
            return this.$t("order.unlimited");
          }
          return `${year}${this.$t("message.year")}${
            valid_from && valid_to
              ? `（${moment(valid_from).format("YYYY-MM-DD")} ~ ${moment(
                  valid_to
                ).format("YYYY-MM-DD")}）`
              : ""
          }`;
        }
        return "";
      }
    },
    methods: {
      textValue(service){
        return [SERVICE_ID_GOOGLE_CID].includes(~~service.service_id)
        ? service.text
        : `${Number(service.standard_count) + Number(service.extra_count)}${
            service.unit_desc
          }`;
      },
      renderExtra(service) {
       if (
          [
            SERVICE_ID_DISCOVERY,
            SERVICE_ID_ERPAPI,
            SERVICE_ID_ERPHELP,
            SERVICE_ID_BILLS,
            SERVICE_ID_PROCESS,
            SERVICE_ID_STAT,
            SERVICE_ID_GOOGLE_CID,
            SERVICE_ID_ADS_ADVANCE,
            SERVICE_ID_ADS_SERVICE,
            SERVICE_ID_STATION
          ].includes(~~service.service_id)
        ) {
          return "";
        }
        return `
          （${this.$t('service.standard')}
          ${service.standard_count + service.unit_desc}
          ${service.extra_count > 0 ? '+' + this.$t('service.extra') + service.extra_count + service.unit_desc : ''}）
        `
      }
    }
  }
</script>
